import { render, staticRenderFns } from "./cg-exclusivePopup.vue?vue&type=template&id=a96d8e48"
import script from "./cg-exclusivePopup.vue?vue&type=script&lang=js"
export * from "./cg-exclusivePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports